import React, { Fragment, useMemo } from 'react';
import { OnboardingLayout } from 'layouts/OnboardingLayout';
import { useTranslation } from 'hooks/useTranslation';
import { useMetrics } from 'hooks/metrics/useMetrics';
import './style.scss';
import { OnboardingLoading } from 'components/onboarding/components/OnboardingLoading';
import { useQRlinkingConfig } from '../hooks/useQRlinkingConfig';
import { QR_LINKING_CALL_CENTER_KEYS } from '../translationKeys';

export const QRLinkingCallCenter = () => {
  const { enableChat } = useQRlinkingConfig();

  const { buildMetricsEvent, sendMetricsEvent } = useMetrics();
  const { translationMapper } = useTranslation();
  const translatedTexts = useMemo(
    () => translationMapper(QR_LINKING_CALL_CENTER_KEYS),
    [translationMapper],
  );

  return (
    <Fragment>
      <OnboardingLoading show={false} />
      <OnboardingLayout type={'QRLinking'}>
        <Fragment>
          <h2 className="QRLinkingCallCenter__Title">
            {translatedTexts.TITLE_1}
            <br />
            {translatedTexts.TITLE_2}
          </h2>

          <p className="QRLinkingCallCenter__P1">
            {translatedTexts.P1_TEXT_1}
          </p>

          <p className="QRLinkingCallCenter__Phone">
            {translatedTexts.P1_TEXT_2}
          </p>

          <p className="QRLinkingCallCenter__P2">
            {translatedTexts.P2_TEXT_1}
            <br />
            {translatedTexts.P2_TEXT_2}
            <br />
            {translatedTexts.P2_TEXT_3}
          </p>

          {enableChat && (
            <Fragment>
              <p className="QRLinkingCallCenter__P3__P1">
                {translatedTexts.P3_PART_1}
              </p>

              <p className="QRLinkingCallCenter__P3__P2">
                {translatedTexts.P3_PART_2}

                <a
                  className="QRLinkingCallCenter__P3__P2__chat"
                  href={translatedTexts.P3_PART_3_HREF || ''}
                  target="_blank"
                >
                  {translatedTexts.P3_PART_3}
                </a>
                <br />
                {translatedTexts.P3_PART_4}
              </p>
            </Fragment>
          )}
        </Fragment>
      </OnboardingLayout>
    </Fragment>
  );
};
